module.exports = __webpack_public_path__ + "img/位图(1).68d212aa.png";